import { render, staticRenderFns } from "./CertificateModalBody.vue?vue&type=template&id=5609bf71&scoped=true&"
import script from "./CertificateModalBody.vue?vue&type=script&lang=js&"
export * from "./CertificateModalBody.vue?vue&type=script&lang=js&"
import style0 from "./CertificateModalBody.vue?vue&type=style&index=0&id=5609bf71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609bf71",
  null
  
)

export default component.exports